import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { TextOptions } from "../../components/canvas/types/textTypes";
import type { BackgroundOptions as CanvasBackgroundOptions } from "../../components/canvas/types/backgroundTypes";
import type { ImageOptions } from "@/components/canvas/types/imageTypes";

// TODO move to types
type BackgroundOptions = Required<CanvasBackgroundOptions> | null;

type CanvasSliceState = {
  imageOptions: ImageOptions;
  textOptions: TextOptions;
  backgroundOptions: BackgroundOptions;
  isSizeRatioLocked: boolean;
};

const initialState: CanvasSliceState = {
  imageOptions: null,
  textOptions: null,
  backgroundOptions: null,
  isSizeRatioLocked: false,
};

const canvasSlice = createSlice({
  name: "canvasSlice",
  initialState,
  reducers: {
    setImageOptions(state, { payload }: PayloadAction<CanvasSliceState["imageOptions"]>) {
      state.imageOptions = payload;
    },
    setTextOptions(state, { payload }: PayloadAction<CanvasSliceState["textOptions"]>) {
      state.textOptions = payload;
    },
    setBackgroundOptions(state, { payload }: PayloadAction<CanvasSliceState["backgroundOptions"]>) {
      state.backgroundOptions = payload;
    },
    setIsSizeRatioLocked(state, { payload }: PayloadAction<CanvasSliceState["isSizeRatioLocked"]>) {
      state.isSizeRatioLocked = payload;
    },
    resetCurrentCanvasState(state) {
      state.imageOptions = null;
      state.textOptions = null;
      state.backgroundOptions = null;
    },
  },
});

const canvasReducer = canvasSlice.reducer;

const { setImageOptions, setTextOptions, setBackgroundOptions, setIsSizeRatioLocked, resetCurrentCanvasState } =
  canvasSlice.actions;

export {
  canvasReducer,
  setImageOptions,
  setTextOptions,
  setBackgroundOptions,
  setIsSizeRatioLocked,
  resetCurrentCanvasState,
};
